import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1.13a3.333 3.333 0 0 0-3.333 3.333v6.667c0 .368.298.667.666.667h2v2.333a.667.667 0 1 0 1.334 0v-2.333h2a.667.667 0 0 0 .666-.667V4.446A3.333 3.333 0 0 0 8 1.13m2 5.564V5.483l-4 1.75v1.211zM6 9.899v.564h4V8.15zm0-4.122 3.956-1.73A2 2 0 0 0 6 4.463z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })